import { components } from "@/api-schema";
import { CustomerType } from "@/api-schema-enums";
import { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";

type CustomerTableType = components["schemas"]["Customer"] & RowWithIdentifier;

export const getCustomerDisplayName = (customer: CustomerTableType): string => {
  if (customer.type === CustomerType.Business && customer.customerCompanyName) {
    return customer.customerCompanyName;
  }

  return [customer.lastName, customer.firstName].filter(Boolean).join(", ");
};
